/* tslint:disable */
/* eslint-disable */
/**
 * Commerce List App Service
 * This is to provide all the list related operations at data tier.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: shikha.raghava@amway.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const Exceptions = {
    RationingService: 'RATIONING SERVICE',
    PromotionService: 'PROMOTION SERVICE',
    FulfillmentService: 'FULFILLMENT SERVICE',
    ProfileService: 'PROFILE SERVICE',
    AccountService: 'ACCOUNT SERVICE',
    AccountSearchService: 'ACCOUNT SEARCH SERVICE',
    ProductService: 'PRODUCT SERVICE',
    ProductValidationService: 'PRODUCT VALIDATION SERVICE',
    ListDataService: 'LIST DATA SERVICE',
    AccountType: 'ACCOUNT TYPE',
    SpecifiedUser: 'SPECIFIED USER',
    Anonymous: 'ANONYMOUS',
    NonAbo: 'NON ABO',
    AwardLevel: 'AWARD LEVEL',
    LosService: 'LOS SERVICE',
    InvalidProduct: 'INVALID PRODUCT',
    EntityVersionConflict: 'ENTITY_VERSION_CONFLICT',
    BlockAndPrivilegeService: 'BLOCK_AND_PRIVILEGE_SERVICE'
} as const;
export type Exceptions = typeof Exceptions[keyof typeof Exceptions];


export function ExceptionsFromJSON(json: any): Exceptions {
    return ExceptionsFromJSONTyped(json, false);
}

export function ExceptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Exceptions {
    return json as Exceptions;
}

export function ExceptionsToJSON(value?: Exceptions | null): any {
    return value as any;
}

